// Data access for the server announcements feature: rotating in-game chat
// messages the server posts on an interval.

import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const CONFIG_DOC = 'serverAnnouncements';

export const DEFAULT_ANNOUNCEMENTS = {
  enabled: false,
  intervalMinutes: 15,
  messages: [],
};

/** Read the config, falling back to the defaults when nothing is saved yet. */
export const getAnnouncements = async () => {
  const snap = await getDoc(doc(db, 'siteConfig', CONFIG_DOC));
  if (!snap.exists()) return { ...DEFAULT_ANNOUNCEMENTS };
  const data = snap.data();
  return {
    enabled: Boolean(data.enabled),
    intervalMinutes: Number(data.intervalMinutes) || DEFAULT_ANNOUNCEMENTS.intervalMinutes,
    messages: Array.isArray(data.messages)
      ? data.messages.filter((m) => typeof m === 'string')
      : [],
  };
};

/**
 * Save the config. Field set MUST stay in sync with the serverAnnouncements
 * rule in firestore.rules.
 */
export const saveAnnouncements = async (config) => {
  const messages = (Array.isArray(config.messages) ? config.messages : [])
    .map((m) => String(m).trim().slice(0, 200))
    .filter(Boolean)
    .slice(0, 20);

  // Round to an integer — the game plugin reads Firestore's integerValue only.
  const intervalMinutes = Math.round(Number(config.intervalMinutes));
  const cleaned = {
    enabled: Boolean(config.enabled),
    intervalMinutes:
      Number.isFinite(intervalMinutes) && intervalMinutes >= 1 && intervalMinutes <= 1440
        ? intervalMinutes
        : DEFAULT_ANNOUNCEMENTS.intervalMinutes,
    messages,
  };

  await setDoc(doc(db, 'siteConfig', CONFIG_DOC), cleaned);
  return cleaned;
};
